<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat tile class="elevation-2">
            <v-card v-if="userListError" key="userListErrorYes" class="pa-3">
              {{ userListErrorMessage }}
            </v-card>
          <v-card-title class="py-3 px-4">
            All Users
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="$vuetify.breakpoint.smAndUp"
            :headers="headers"
            :items="allUsers"
            :search="search"
            class="pa-3 tabulardata"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left" width="250">
                <router-link :to="{ name: 'GiftCards', params: { user_id: props.item.id } }">{{ props.item.first_name }} </router-link>  
              </td>
              <td class="text-xs-left">{{ props.item.last_name }}</td>
              <td class="text-xs-left">{{ props.item.email }}</td>
              <td class="text-xs-left">{{ props.item.balance }}</td>
               <td class="text-xs-left">
                 <router-link :to="{ name: 'UserTransactions', params: { user_id: props.item.id }}">
                    <v-btn 
                    color="accent"> 
                    <v-icon left dark size="16">send</v-icon>VIEW TRANSECTIONS
                  </v-btn>
                 </router-link>
               </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
          <v-data-iterator
            v-else
            :items="allUsers"
            content-tag="v-layout"
            row
            wrap
            :search="search"
            class="pa-3"
          >
            <v-flex
              slot="item"
              slot-scope="props"
              xs12
              sm6
              md4
              lg3
            >
              <v-list-tile>
                <v-list-tile-content>{{ props.item.first_name }}</v-list-tile-content>
              </v-list-tile>
                  <v-list-tile>
                <v-list-tile-content>{{ props.item.last_name }}</v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.email }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.balance }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-data-iterator>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import Env from "../environment";
import { mapActions, mapGetters } from 'vuex'
import AuthApi from './controllers/AuthApi';

export default {
  name: "Users",
  props: {
    msg: String
  },
  data: () => ({
    search: "",
    userListError: false,
    userListErrorMessage: "",
    headers: [
      { text: "First Name", value: "first_name", },
      { text: "Last Name", value: "last_name", sortable: false, },
      { text: "Email", value: "email", sortable: false,},
      { text: "Balance", value: "balance", },
      { text: "Actions", value: "", },
    ],
  }),
  computed: {
    allUsers() {
      return this.$store.getters.getUsers;
    },
  },
  watch: {
  },  
  created() {
    this.$emit("load");
    this.init();
  },
  mounted() {},
  methods: {
    /**
     * To get users and store it
     * @function
     * @returns {undefined}
     */
    init() {
      AuthApi.getApi(`${Env.giftcard_url}/api/user/list`)
        .then(res => {
          this.$store.dispatch("SET_USERS_LIST", res.data.payload.data);
        })
        .then(() => {
          this.$emit("loadEnd");
        })
        .catch(err => {
          if (err.response.data.declaration === "auth_token_needs_refresh") {
            this.$emit("expire");
          } else if (err.response.data.declaration === "invalid_business") {
            this.occasionListError = true;
            this.occasionListErrorMessage = err.response.data.payload.message;
            this.$emit("loadEnd");
          } else {
            console.log(err);
          }
        });
    },
    ...mapActions({
      snackbar: 'snackbar/snackbar'
    }),
  }
};
</script>
<style scoped>

</style>